
import React from 'react';

interface LogoProps {
  className?: string;
  width?: number | string;
  height?: number | string;
}

export const LogoIcon: React.FC<LogoProps> = ({ className = '', width = 40, height = 40 }) => (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 100 100" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M50 5L90 27.5V72.5L50 95L10 72.5V27.5L50 5Z" fill="#FFCE1B"/>
    <path d="M50 20L75 34V66L50 80L25 66V34L50 20Z" fill="#0A0A0A"/>
    {/* Upward Facing Nexus Arrow */}
    <path d="M50 30L70 70H58L50 52L42 70H30L50 30Z" fill="#FFCE1B"/>
    <circle cx="50" cy="12" r="3" fill="#0A0A0A"/>
    <circle cx="82" cy="30" r="3" fill="#0A0A0A"/>
    <circle cx="82" cy="70" r="3" fill="#0A0A0A"/>
    <circle cx="50" cy="88" r="3" fill="#0A0A0A"/>
    <circle cx="18" cy="70" r="3" fill="#0A0A0A"/>
    <circle cx="18" cy="30" r="3" fill="#0A0A0A"/>
  </svg>
);

export const LogoPrimary: React.FC<LogoProps> = ({ className = '', width = 200, height = 50 }) => (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 400 100" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Nexus Hexagon Icon */}
    <path d="M50 10L84.641 30V70L50 90L15.359 70V30L50 10Z" fill="#FFCE1B"/>
    <path d="M50 25L72 37.5V62.5L50 75L28 62.5V37.5L50 25Z" fill="#0A0A0A"/>
    {/* Upward Facing Nexus Arrow */}
    <path d="M50 35L66 65H58L50 52L42 65H34L50 35Z" fill="#FFCE1B"/>
    <path d="M50 20L50 35M24 35L37 27.5M76 35L63 27.5M24 65L37 72.5M76 65L63 72.5M50 80L50 65" stroke="#FFCE1B" stroke-width="2" stroke-linecap="round"/>
    
    {/* Geometric Wordmark "COINNEXS" - White Version */}
    <g fill="#FFFFFF">
      <path d="M135 65C126.716 65 120 58.2843 120 50C120 41.7157 126.716 35 135 35H142V42H135C130.582 42 127 45.5817 127 50C127 54.4183 130.582 58 135 58H142V65H135Z"/>
      <path d="M165 65C156.716 65 150 58.2843 150 50C150 41.7157 156.716 35 165 35C173.284 35 180 41.7157 180 50C180 58.2843 173.284 65 165 65ZM165 58C169.418 58 173 54.4183 173 50C173 45.5817 169.418 42 165 42C160.582 42 157 45.5817 157 50C157 54.4183 160.582 58 165 58Z"/>
      <path d="M190 35H197V65H190V35Z"/>
      <path d="M207 65V35H214L224 53V35H231V65H224L214 47V65H207Z"/>
      <path d="M241 65V35H248L258 53V35H265V65H258L248 47V65H241Z"/>
      <path d="M275 65V35H295V42H282V47H292V54H282V58H295V65H275Z"/>
      <path d="M305 35H312.5L318 45L323.5 35H331L322 50L331 65H323.5L318 55L312.5 65H305L314 50L305 35Z"/>
      <path d="M340 42V45H357V51C357 55 354 57 350 57H340V65H350C355 65 357 62 357 58V55H340V51C340 47 343 45 347 45H357V35H347C342 35 340 38 340 42Z"/>
    </g>
  </svg>
);

export const LogoLightBg: React.FC<LogoProps> = ({ className = '', width = 200, height = 50 }) => (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 400 100" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M50 10L84.641 30V70L50 90L15.359 70V30L50 10Z" fill="#FFCE1B"/>
    <path d="M50 35L66 65H58L50 52L42 65H34L50 35Z" fill="#0A0A0A"/>
    <g fill="#0A0A0A">
      <path d="M135 65C126.716 65 120 58.2843 120 50C120 41.7157 126.716 35 135 35H142V42H135C130.582 42 127 45.5817 127 50C127 54.4183 130.582 58 135 58H142V65H135Z"/>
      <path d="M165 65C156.716 65 150 58.2843 150 50C150 41.7157 156.716 35 165 35C173.284 35 180 41.7157 180 50C180 58.2843 173.284 65 165 65ZM165 58C169.418 58 173 54.4183 173 50C173 45.5817 169.418 42 165 42C160.582 42 157 45.5817 157 50C157 54.4183 160.582 58 165 58Z"/>
      <path d="M190 35H197V65H190V35Z"/>
      <path d="M207 65V35H214L224 53V35H231V65H224L214 47V65H207Z"/>
      <path d="M241 65V35H248L258 53V35H265V65H258L248 47V65H241Z"/>
      <path d="M275 65V35H295V42H282V47H292V54H282V58H295V65H275Z"/>
      <path d="M305 35H312.5L318 45L323.5 35H331L322 50L331 65H323.5L318 55L312.5 65H305L314 50L305 35Z"/>
      <path d="M340 65H350C355 65 357 62 357 58V55H340V51C340 47 343 45 347 45H357V35H347C342 35 340 38 340 42V45H357V51C357 55 354 57 350 57H340V65Z"/>
    </g>
  </svg>
);

export const LogoAllGold: React.FC<LogoProps> = ({ className = '', width = 200, height = 50 }) => (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 400 100" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M50 10L84.641 30V70L50 90L15.359 70V30L50 10Z" stroke="#FFCE1B" stroke-width="4"/>
    <path d="M50 35L66 65H58L50 52L42 65H34L50 35Z" fill="#FFCE1B"/>
    <g fill="#FFCE1B">
      <path d="M135 65C126.716 65 120 58.2843 120 50C120 41.7157 126.716 35 135 35H142V42H135C130.582 42 127 45.5817 127 50C127 54.4183 130.582 58 135 58H142V65H135Z"/>
      <path d="M165 65C156.716 65 150 58.2843 150 50C150 41.7157 156.716 35 165 35C173.284 35 180 41.7157 180 50C180 58.2843 173.284 65 165 65ZM165 58C169.418 58 173 54.4183 173 50C173 45.5817 169.418 42 165 42C160.582 42 157 45.5817 157 50C157 54.4183 160.582 58 165 58Z"/>
      <path d="M190 35H197V65H190V35Z"/>
      <path d="M207 65V35H214L224 53V35H231V65H224L214 47V65H207Z"/>
      <path d="M241 65V35H248L258 53V35H265V65H258L248 47V65H241Z"/>
      <path d="M275 65V35H295V42H282V47H292V54H282V58H295V65H275Z"/>
      <path d="M305 35H312.5L318 45L323.5 35H331L322 50L331 65H323.5L318 55L312.5 65H305L314 50L305 35Z"/>
      <path d="M340 65H350C355 65 357 62 357 58V55H340V51C340 47 343 45 347 45H357V35H347C342 35 340 38 340 42V45H357V51C357 55 354 57 350 57H340V65Z"/>
    </g>
  </svg>
);

export const LogoMonochrome: React.FC<LogoProps> = ({ className = '', width = 200, height = 50 }) => (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 400 100" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M50 10L84.641 30V70L50 90L15.359 70V30L50 10Z" stroke="white" stroke-width="2"/>
    <path d="M50 35L66 65H58L50 52L42 65H34L50 35Z" fill="white"/>
    <g fill="white">
      <path d="M135 65C126.716 65 120 58.2843 120 50C120 41.7157 126.716 35 135 35H142V42H135C130.582 42 127 45.5817 127 50C127 54.4183 130.582 58 135 58H142V65H135Z"/>
      <path d="M165 65C156.716 65 150 58.2843 150 50C150 41.7157 156.716 35 165 35C173.284 35 180 41.7157 180 50C180 58.2843 173.284 65 165 65ZM165 58C169.418 58 173 54.4183 173 50C173 45.5817 169.418 42 165 42C160.582 42 157 45.5817 157 50C157 54.4183 160.582 58 165 58Z"/>
      <path d="M190 35H197V65H190V35Z"/>
      <path d="M207 65V35H214L224 53V35H231V65H224L214 47V65H207Z"/>
      <path d="M241 65V35H248L258 53V35H265V65H258L248 47V65H241Z"/>
      <path d="M275 65V35H295V42H282V47H292V54H282V58H295V65H275Z"/>
      <path d="M305 35H312.5L318 45L323.5 35H331L322 50L331 65H323.5L318 55L312.5 65H305L314 50L305 35Z"/>
      <path d="M340 65H350C355 65 357 62 357 58V55H340V51C340 47 343 45 347 45H357V35H347C342 35 340 38 340 42V45H357V51C357 55 354 57 350 57H340V65Z"/>
    </g>
  </svg>
);
